import { augmentTrackingHeaders } from './chunk-JPNTSM5L.js';
import Debug from '@bytel/debug';

var debug = Debug("logger:log-api.transporter");
var LogApiTransporter = class {
  isSending = false;
  queue = [];
  lockQueue = Promise.resolve();
  timeoutEnvoi = null;
  config;
  constructor(config) {
    this.config = config;
  }
  async flush() {
    if (!this.isSending) {
      this.isSending = true;
      try {
        await this.send();
      } catch (e) {
        console.error("Erreur lors de l'envoi des logs prisme", e);
      } finally {
        this.isSending = false;
      }
    }
  }
  _debugQueue() {
    return this.queue.map((m) => {
      return {
        trackerId: m.ctx.trackerId,
        nom: m.events[0].nom,
        idEv: m.events[0].idEv
      };
    });
  }
  async push(messagePrisme) {
    await this.lockQueue;
    this.queue.push(messagePrisme);
    await this.sendIfNecessary();
  }
  enrichLog(messagePartiel) {
    return {
      st: this.config.st,
      env: this.config.environment,
      ...messagePartiel
    };
  }
  async sendIfNecessary() {
    this.resetTimeout();
    if (this.queue.length > 0 && this.queue.length >= this.config.sendQueueMaxSize) {
      await this.send();
    }
  }
  async send() {
    await this.lockQueue;
    if (this.queue.length > 0) {
      this.resetTimeout();
      this.lockQueue = new Promise(async (resolve) => {
        const messagesPrisme = await Promise.all(
          this.queue.map((m) => this.enrichLog(m))
        );
        try {
          debug("Envoi des logs \xE0 LOGAPI");
          await fetch(this.config.urlEndpoint, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              // FIXME: Est-ce que ça va pas planter parce que le trackerId n'est pas le bon
              ...augmentTrackingHeaders(
                this.config.st,
                this.config.getTrackerId()
              )
            },
            body: JSON.stringify(messagesPrisme)
          });
        } catch (e) {
          console.error(
            "[prisme-logger] Erreur lors de l'envoi des logs \xE0 LOGAPI",
            e
          );
        } finally {
          this.queue = [];
          debug("Nettoyage de la queue", this.queue);
          resolve();
        }
      });
    }
    return this.lockQueue;
  }
  resetTimeout() {
    if (this.timeoutEnvoi) {
      clearTimeout(this.timeoutEnvoi);
    }
    this.timeoutEnvoi = setTimeout(
      async () => await this.send(),
      this.config.sendQueueTimeoutInMs
    );
  }
};

export { LogApiTransporter };
//# sourceMappingURL=chunk-GQYSJ5AC.js.map
//# sourceMappingURL=chunk-GQYSJ5AC.js.map